module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//tiger_5_1.png?v=1bf98ffe";